import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { createNewWorkbook } from '~src/app/actions/spaces/ContentExplorerCreateActions';

import { errorBoundary, sendTelemetryErrorEvent } from '../../../common/react/components/ErrorBoundary';
import { getPersonalSpace } from '../../../personalSpace/actions/PersonalSpaceActions';
import { selectPersonalSpace } from '../../../personalSpace/selectors/PersonalSpaceSelector';
import { clearSpaceContentCountsAction } from '../../actions/spaces/ContentCountsActions';
import { showContentTypes } from '../../actions/spaces/ContentExplorerFilterActions';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { selectCurrentlyApplicableContentTypes, selectDefaultContentTypeFilterValues } from '../../selectors/ContentFilterSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps,MapStateToProps } from '../../utils/ConnectUtils';
import {
  PersonalSpace,
  PersonalSpaceDispatchProps,
  PersonalSpaceOwnProps,
  PersonalSpaceStateProps} from './PersonalSpace';

const mapStateToProps: MapStateToProps<PersonalSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  urls: siteUrlsSelector(state),
  personalSpace: selectPersonalSpace(state)
});

const mapDispatchToProps: MapDispatchToProps<PersonalSpaceDispatchProps> = (dispatch) =>
  bindActionCreators({
    filterSelected: showContentTypes,
    requestSpaceContents,
    clearContentCounts: clearSpaceContentCountsAction,
    getPersonalSpace,
    createNewWorkbook
  }, dispatch);

const ConnectedPersonalSpaceInternal: React.ComponentClass<PersonalSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(PersonalSpace);

export const ConnectedPersonalSpace =
  errorBoundary<PersonalSpaceOwnProps>
    (sendTelemetryErrorEvent)(ConnectedPersonalSpaceInternal);
